import React, { useState, useEffect } from 'react';
import "./SearchProject.scss" 

import { Layout, Typography, Space, Row, Col, Select, Button, Input, DatePicker } from 'antd'
import { Mixpanel } from '../../tools/MixPanel';
import IconSelect from '../Select/IconSelect';

const SearchProject = ({onSearch, projects}) => {
    const { Title, Text } = Typography;
    const { Search } = Input;
    const { Option } = Select;
    const { RangePicker } = DatePicker;

    const [search, setSearch] = useState('')
    const [startDate, setInitDate] = useState('')
    const [endDate, setEndDate] = useState('')
    const [status, setStatus] = useState('')    
    const [value, setValue] = useState('Active')

    const onCalendarChange = (date) => {
        if (date[0] != null) {
            setInitDate(date[0])
        } else {
            setInitDate('')
        }
        if (date[1] != null) {
            setEndDate(date[1])
        } else {
            setEndDate('')
        }    
    }
    
    const handleChange = (value) => {
        setStatus(value)
        setValue(value)
    }

    const onInitSearch = (value) => {
        setSearch(value)
    }

    const applySearch = () => {
        let projectsFiltered = projects

        if (search != '') {
            projectsFiltered = projectsFiltered.filter(project => project.name.toUpperCase().includes(search.toUpperCase()) || project.client.toUpperCase().includes(search.toUpperCase())   )
        }

        if (status != '') {
            projectsFiltered = projectsFiltered.filter(project => project.simile_status == status)            
        }

        if (startDate != '') {         
            projectsFiltered = projectsFiltered.filter(project => {
                const creationDate = new Date(project.creation) 
                if (creationDate >= startDate) {
                    return project
                }
            })    
        }        

        if (endDate != '') {         
            projectsFiltered = projectsFiltered.filter(project => {
                const creationDate = new Date(project.creation) 
                if (creationDate <= endDate) {
                    return project
                }
            })    
        }        

		Mixpanel.track('filter-project', {
			search: search,
			status: status,
			startDate: startDate,
			endDate: endDate,
        })
                
        onSearch(projectsFiltered)
    }

    useEffect(() => {
        applySearch()
    }, [status, search, startDate, endDate])



  const statusType = {
    open: 'Active',
    archived: 'Archived',
    completed: 'Completed'
}

  const statusSelect = [
    {
      value: statusType.open,
      color: "#2074C1",
    },
    {
      value:statusType.completed,
      color: "#4cb865",
    },
    {
      value: statusType.archived,
      color: "#979797",
    } 
  ];

    return ( 
        <Row justify="space-between" className="searchBar container" style={{marginTop: '26px', marginBottom:'20px', padding: '14px 20px' }} >
            
            <Col span={12}>
                <Row>
                    <Col span={6} >
                        <Space direction="vertical" >
                            <Text strong>Select</Text>
                            <IconSelect value={value} style={{ marginRight: 20, width: 130 }}  handleChange={handleChange} options={statusSelect} />
                        </Space>
                    </Col>

                    <Col span={16} style={{marginLeft:'5px'}} >
                    <Space direction="vertical" >
                        <Text strong>Date created between</Text>
                        <RangePicker onCalendarChange={onCalendarChange} />
                    </Space>
                    </Col>
                </Row>

            </Col>
            
            <Col span={8}>
            <Row justify="end" style={{paddingTop:'30px'}} >
                <Search allowClear placeholder="Search" onSearch={value => onInitSearch(value)} style={{ width: 325 }}/>
            </Row>
            </Col>
      
        </Row>
     );
}
 
export default SearchProject;